import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  IAddressSuggestionRequest,
  IAddressSuggestionResponse,
  IReverseGeocodingRequest
} from 'models/app'

export const appApi = {
  getAddresses(
    data: IAddressSuggestionRequest
  ): Promise<AxiosResponse<IAddressSuggestionResponse>> {
    return privateApi.post<IAddressSuggestionResponse>(
      `dadata/address?address=${data.address}&isCityOnly=${data?.isCityOnly ?? 'false'
      }`
    )
  },
  getAddressByGeo(
    data: IReverseGeocodingRequest
  ): Promise<AxiosResponse<IAddressSuggestionResponse>> {
    return privateApi.post<IAddressSuggestionResponse>('dadata/reverse-geocoding', data)
  }
}
